/** Every `RoutingPolicyName` member, in the exact order declared by the YAML enum. */
export const ROUTING_POLICY_NAMES = ['cheapest', 'fastest', 'balanced'];
/** Every `QuoteFailedProviderReason` member, in the exact order declared by the YAML enum. */
export const QUOTE_FAILED_PROVIDER_REASONS = [
    'timeout',
    'auth_error',
    'provider_error',
];
/** Every `QuoteStatus` member, in the exact order declared by the YAML enum. */
export const QUOTE_STATUSES = ['complete', 'partial'];
//# sourceMappingURL=quote.js.map